import type { Components } from '@mui/material/styles';

export default function MuiFormControlLabel(): Components['MuiFormControlLabel'] {
  return {
    defaultProps: {
      slotProps: {
        typography: {
          variant: 'body2',
        },
      },
    },
    styleOverrides: {
      root: {
        marginLeft: 0,
        marginRight: 0,
      },
    },
  };
}
